import React from 'react';
import Cell from './Cell';
import { StageType } from '../types';

interface NextTetrominoProps {
  tetromino: (string | number)[][];
}

const NextTetromino: React.FC<NextTetrominoProps> = ({ tetromino }) => {
  // Create a small 4x4 grid for the next tetromino
  const nextStage: StageType = Array.from(Array(4), () =>
    new Array(4).fill([0, 'clear']) as [string | number, string][]
  );

  // Center the tetromino in the preview box
  const offsetX = Math.floor((4 - tetromino[0].length) / 2);
  const offsetY = Math.floor((4 - tetromino.length) / 2);

  // Place the tetromino in the preview grid
  tetromino.forEach((row, y) => {
    row.forEach((value, x) => {
      if (value !== 0) {
        nextStage[y + offsetY][x + offsetX] = [value, 'clear'] as [string | number, string];
      }
    });
  });

  return (
    <div className="next-tetromino">
      <h4>Next:</h4>
      <div className="next-tetromino-grid">
        {nextStage.map((row, y) => 
          row.map((cell, x) => <Cell key={`${y}-${x}`} type={cell[0]} />)
        )}
      </div>
    </div>
  );
};

export default NextTetromino;